import type {
  ConversationLanguageCode,
  LanguageName,
} from 'lib-shared-languages';
import {
  defaultConversationLanguageCode,
  getLanguageName,
} from 'lib-shared-languages';
import { useMemo } from 'react';

import { useServerStorage } from 'utils/useServerStorage';

export type PreferredLanguageValues = {
  /** The 2-letter language code used for the summary. Example: 'en', 'da' */
  readonly preferredLanguageCode?: ConversationLanguageCode;
  /** The full, human friendly, name of the language used for the summary */
  readonly preferredLanguage?: LanguageName;
};

export const useConversationPreferredLanguage = (): PreferredLanguageValues => {
  const { data } = useServerStorage('user');
  const { preferredLanguage: preferredLanguageCode } = {
    preferredLanguage: defaultConversationLanguageCode,
    ...data['agent_copilot'],
  };

  return useMemo(
    () => ({
      preferredLanguageCode,
      preferredLanguage: getLanguageName(preferredLanguageCode) || undefined,
    }),
    [preferredLanguageCode],
  );
};
